var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{staticClass:"el-form k-form",class:[
  _vm.labelPosition ? 'el-form--label-' + _vm.labelPosition : '',
  { 'el-form--inline': _vm.inline === true || _vm.inline === 'true' }
],style:(_vm.formStyle)},[_c('div',{staticClass:"k-form-body"},[_vm._t("default")],2),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }